import type { StockGroupDto } from '@eombor/contracts';

/**
 * "Bu mahsulot QAYSI OMBORLARDA bor" — qidiruv natijasidan hisoblanadigan javob.
 *
 * `StockGroupDto.places` KATAK aniqligida keladi va bu skladchining o'lchovi.
 * Buyurtmachining savoli bir pog'ona yuqorida: u katakka bormaydi, mahsulotni
 * unga skladchi beradi. Shuning uchun kataklar ombor bo'yicha yig'iladi.
 *
 * Yig'ish `warehouseId` bo'yicha, NOM bo'yicha emas: ikki tashkilotda bir xil
 * nomli ombor bo'lishi mumkin va nom bo'yicha yig'ilsa ular bitta qatorga
 * qo'shilib ketardi — talabnoma esa noto'g'ri omborga tushardi.
 */
export interface WarehouseStock {
  warehouseId: string;
  warehouseName: string;
  availableQty: number;
}

/** Ko'p qoldiq birinchi: buyurtmachi odatda eng to'lasidan oladi. */
export const warehousesOf = (group: StockGroupDto): WarehouseStock[] => {
  const totals = new Map<string, WarehouseStock>();
  for (const place of group.places) {
    const row = totals.get(place.warehouseId);
    if (row === undefined) {
      totals.set(place.warehouseId, {
        warehouseId: place.warehouseId,
        warehouseName: place.warehouseName,
        availableQty: place.availableQty,
      });
      continue;
    }
    row.availableQty += place.availableQty;
  }
  return [...totals.values()].sort((a, b) => b.availableQty - a.availableQty);
};
